<template>
  <div>
    <div style="height:calc(100vh - 120px)" ref="productDivisionGrid"></div>
  </div>
</template>
<script>
import $ from '../../helpers/jquery-bridge'
import {enableExportExcel} from '../../helpers/export-helper'
import {jsonDropDownEditor} from '../../helpers/kendo-editors'
import {mapGetters} from 'vuex'
import security from '@/mixins/security'
import axios from 'axios'

export default {
  mixins: [security],
  mounted() {
    let vm = this
    let grid = $(this.$refs.productDivisionGrid)
      .kendoGrid({
        dataSource: new kendo.data.DataSource({
          type: 'aspnetmvc-ajax',
          serverPaging: true,
          serverFiltering: true,
          serverSorting: true,
          pageSize: 15,
          transport: {
            read: {
              type: 'GET',
              url: '/api/config/productDivision',
              data: () => ({clientId: this.clientId}),
              dataType: 'json',
            },
          },
          schema: {
            data: 'data',
            errors: 'errors',
            total: 'total',
            model: {
              id: 'productClientLinkId',
              fields: {
                client: {type: 'string'},
                market: {type: 'string'},
                product: {type: 'string'},
                description: {type: 'string'},
              },
            },
          },
          error: function() {
            grid.one('dataBinding', e => {
              e.preventDefault()
            })
          },
        }),
        toolbar: [],
        editable: false,
        filterable: true,
        sortable: true,
        pageable: true,
        columns: [
          {
            title: 'Client',
            field: 'client',
            width: 182,
            attributes: {style: 'text-align: left;'},
          },
          {
            title: 'Market',
            field: 'market',
            width: 110,
            attributes: {style: 'text-align: left;'},
          },
          {
            title: 'Product',
            field: 'product',
            width: 132,
            attributes: {style: 'text-align: left;'},
          },
          {
            title: 'Description',
            field: 'description',
            width: 382,
            attributes: {style: 'text-align: left;'},
          },
          {},
        ],
        detailInit: detailInit,
        detailCollapse: () => grid.dataSource.read(),
        detailExpand: container => container.masterRow.find('.k-grid-delete').hide(),
      })
      .getKendoGrid()
    enableExportExcel(grid, '/api/config/productDivision/exportToExcel')

    function detailInit(expandElement) {
      const productClientLinkId = expandElement.data.productClientLinkId
      let detailDataSource = new kendo.data.DataSource({
        type: 'aspnetmvc-ajax',
        serverPaging: true,
        serverSorting: true,
        serverFiltering: true,
        pageSize: 20,
        transport: {
          create: {
            type: 'POST',
            url: '/api/config/productDivision/createDetail',
            dataType: 'json',
          },
          read: {
            type: 'GET',
            url:
              '/api/config/productDivision/readDetail?productClientLinkId=' + productClientLinkId,
            dataType: 'json',
          },
          update: {
            type: 'PUT',
            url: '/api/config/productDivision/updateDetail',
            dataType: 'json',
          },
          destroy: {
            type: 'DELETE',
            url: '/api/config/productDivision/deleteDetail',
          },
        },
        schema: {
          data: 'data',
          errors: 'errors',
          total: 'total',
          model: {
            id: 'productClientLinkDivisionLinkId',
            fields: {
              productClientLinkDivisionLinkId: {type: 'number', defaultValue: 0},
              productClientLinkId: {
                type: 'number',
                editable: false,
                defaultValue: productClientLinkId,
              },
              divisionId: {type: 'number', validation: {required: true}},
              division: {type: 'string', validation: {required: true}},
              order: {type: 'number'},
            },
          },
        },
        error: function() {
          grid.one('dataBinding', e => {
            e.preventDefault()
          })
        },
      })

      let detailGrid = $(
        "<div style='width: 432px;' id='detail_" + productClientLinkId + "' class='k-content' />",
      )
        .appendTo(expandElement.detailCell)
        .kendoGrid({
          dataSource: detailDataSource,
          scrollable: true,
          sortable: false,
          toolbar: !vm.isReadOnly ? ['create'] : '',
          editable: !vm.isReadOnly && 'inline',
          pageable: true,
          columns: [
            {
              template: '<span class="k-icon k-i-reorder drag-handle" title="Drag to reorder" />',
              attributes: {class: 'drag-handle', style: 'text-align: center'},
              width: 32,
              hidden: this.isReadOnly,
            },
            {
              command: [{name: 'edit'}],
              width: 82,
              attributes: {style: 'text-align: center;'},
              hidden: vm.isReadOnly,
            },
            {
              title: 'Division',
              field: 'division',
              width: 232,
              editor: function(container, options) {
                const clientId = vm.clientId
                return jsonDropDownEditor(
                  'divisionId',
                  'division',
                  '/api/config/productDivision/getDivisions?productClientLinkId=' +
                    productClientLinkId +
                    '&clientId=' +
                    clientId,
                  {
                    filter: 'contains',
                  },
                  true,
                ).call(this, container, options)
              },
            },
            {
              command: [{name: 'destroy'}],
              width: 82,
              attributes: {style: 'text-align: center;'},
              hidden: vm.isReadOnly,
            },
          ],
        })
        .getKendoGrid()

      detailGrid.table.kendoSortable({
        handler: '.drag-handle',
        filter: 'tr:not(tr[data-role=editable])',
        hint: function(element) {
          var table = $('<table style="width: 382px;" class="k-grid k-widget"></table>')

          table.append(element.clone())
          table.css('opacity', 0.82)

          return table
        },
        cursor: 'move',
        placeholder: function() {
          return $('<tr colspan="4" class="placeholder"></tr>')
        },
        change: async e => {
          const skip = detailGrid.dataSource.skip(),
            newIndex = e.newIndex + skip,
            selectedDataItem = detailGrid.dataSource.getByUid(e.item.data('uid'))

          detailDataSource.remove(selectedDataItem)
          detailDataSource.insert(newIndex, selectedDataItem)

          await axios.post('/api/config/productDivision/updateOrder', {
            productClientLinkDivisionLinkId: selectedDataItem.productClientLinkDivisionLinkId,
            productClientLinkId: selectedDataItem.productClientLinkId,
            newIndex: e.newIndex + 1,
          })

          await detailDataSource.read()
        },
      })
    }
  },
  computed: {
    ...mapGetters({clientId: 'authentication/selectedClientId'}),
  },
}
</script>

<style>
.drag-handle {
  cursor: move !important;
}

.placeholder {
  outline-style: dashed;
  outline-width: 1px;
  outline-color: red;
}
</style>
